import { render, staticRenderFns } from "./DirectCosts.vue?vue&type=template&id=e5aa67e4&scoped=true"
import script from "./DirectCosts.vue?vue&type=script&lang=js"
export * from "./DirectCosts.vue?vue&type=script&lang=js"
import style0 from "./DirectCosts.vue?vue&type=style&index=0&id=e5aa67e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5aa67e4",
  null
  
)

export default component.exports